import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toastError } from '@components/Toast';

import AddCertificates from '@features/crm/brands/components/AddCertificates';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

import { changeDateFormat } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

const BrandCertificates = () => {
	const [certificates, setCertificates] = useState([]);
	const [openModal, setOpenModal] = useState(false);
	const [selectedCertificate, setSelectedCertificate] = useState(null);
	const dispatch = useDispatch();
	const { id } = useParams();

	const fetchCertificates = async () => {
		try {
			dispatch(openLoader());
			const { data } = await ApiClient.GET(`${BASE_URL}/brand/${id}/certificates`, '', true);
			setCertificates(data);
			dispatch(closeLoader());
		} catch (error) {
			toastError(error.message);
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		fetchCertificates();
	}, []);

	const handleCloseModal = (isModified) => {
		if (isModified) {
			fetchCertificates();
		}
		setSelectedCertificate(null);
		setOpenModal(false);
	};

	const removeCertificate = async (certificateId) => {
		try {
			dispatch(openLoader());
			await ApiClient.DELETE(`${BASE_URL}/brand/${id}/certificates/${certificateId}`, '', '', true);
			fetchCertificates();
		} catch (error) {
			toastError(error.message);
			dispatch(closeLoader());
		}
	};

	const renderCertificates = () => {
		return certificates?.map((item) => {
			return (
				<div
					key={`certificates_${item.id}`}
					className="single-design-card with-editable certificate-card shadow-1dp"
				>
					<div className="card-top">
						<div className="edit-items">
							<div className="select-and-edit d-flex justify-content-between">
								<div className="custom-chekbox">
									<img
										onClick={() => {
											setSelectedCertificate(item);
											setOpenModal(true);
										}}
										src={`${process.env.PUBLIC_URL}/icons/edit-supplier.svg`}
										alt
									/>
								</div>
								<div className="option">
									<button
										className="btn btn-default"
										type="button"
										id="menu1"
										aria-expanded="false"
										onClick={() => removeCertificate(item.id)}
									>
										<img
											src={`${process.env.PUBLIC_URL}/icons/delete_gray.svg`}
											alt="delete"
										/>
									</button>
								</div>
							</div>
						</div>
						{item?.documentResponse?.docUrl && (
							<img
								className="cursor-pointer file-icon"
								src={item.documentResponse.docUrl}
								alt="certificate-image"
							/>
						)}
						<div className="certificate-badge" />
					</div>
					<div className="card-content text-center">
						<h3 className="regular-14 design-title">{item.certificateType}</h3>
						<p className="regular-12">
							Expired: {changeDateFormat(item.expireDate, 'YYYY-MM-DD', 'DD MMM, YYYY')}
						</p>
					</div>
				</div>
			);
		});
	};

	return (
		<div className="tab-contents">
			<div className="d-flex justify-content-end">
				<button className="button text" onClick={() => setOpenModal(true)}>
					<span className="mr-1 gray_dark_01">Add</span>
					<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" className="ml-1" />
				</button>
			</div>
			<div className="brand-certificates">{renderCertificates()}</div>
			{openModal && (
				<AddCertificates
					selectedCertificate={selectedCertificate}
					isShow={openModal}
					handleClose={handleCloseModal}
					id={id}
				/>
			)}
		</div>
	);
};

export default BrandCertificates;
